/* INIT MAPS */
export function initSingleMap(
  selector,
  hotels,
  uniqueKeyParam,
  uniqueKeyHotels,
  total_nights,
  total_adults,
  total_childs
) {
  if (hotels.length === 0) {
    console.error("No se encontraron hoteles");
    return;
  }

  const map = new google.maps.Map(document.getElementById(selector), {
    center: { lat: hotels[0].latitude, lng: hotels[0].longitude },
    zoom: 10,
  });

  hotels.forEach((hotel) => {
    const marker = new google.maps.Marker({
      position: { lat: hotel.latitude, lng: hotel.longitude },
      map: map,
      title: hotel.name,
    });

    const infoWindow = new google.maps.InfoWindow({
      content: `
                <div class="flex flex-col md:flex-row gap-3 md:max-w-[350px]">
                <div>
                    <img src="${hotel.imagenUrl}" alt="${
        hotel.name
      }" style="width:100%;height:100%;max-height:200px;border-radius:15px;"></div>
      <div class="flex flex-col text-start">
                    <strong class="text-2xl">${hotel.name}</strong>
                    <x-icons.icon-location class="w-5 fill-gray-800"></x-icons.icon-location>
                    <p>${hotel.address}</p>
                    <span class="text-xl font-bold text-green-700 ">${
                      hotel.discountedPrice
                    } $</span>
                    <p class="text-xs text-green-700 ">(Total stay)</p>
                    <p class="text-xs font-bold ">
                        ${total_nights} night${total_nights > 1 ? "s" : ""},
                        ${total_adults} adult${total_adults > 1 ? "s" : ""}
                        ${
                          total_childs > 0
                            ? `${total_childs} child${
                                total_childs > 1 ? "ren" : ""
                              }`
                            : ""
                        }
                    </p>
                    <p class="mb-1 text-xs font-bold ">Includes taxes and charges</p>
                    </div>
                </div>`,
    });

    marker.addListener("mouseover", () => {
      infoWindow.open(map, marker);
    });

    marker.addListener("mouseout", () => {
      infoWindow.close();
    });

    marker.addListener("click", () => {
      const url = `/hotel_view?code=${hotel.code}&uniqueKeyParam=${uniqueKeyParam}&uniqueKeyHotels=${uniqueKeyHotels}`;
      window.open(url, "_blank");
    });
  });
}
